import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { appSettings } from '@app/shared/app-settings';
import { AuthenticatedUser } from '@app/domain/model/authenticated-user';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "ngx-toastr";
import * as i3 from "ngx-cookie-service/cookie-service/cookie.service";
var COOKIE_NAME = 'currentUser';
/**
 * Dealer authentication service.
 *
 * @author Warlock, AIS.PL
 */
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(http, toastrService, cookieService) {
        this.http = http;
        this.toastrService = toastrService;
        this.cookieService = cookieService;
    }
    AuthenticationService.prototype.getCurrentUser = function () {
        var jsonString = this.cookieService.get(COOKIE_NAME);
        return jsonString ? AuthenticatedUser.fromJSON(JSON.parse(jsonString)) : null;
    };
    AuthenticationService.prototype.isLoggedIn = function () {
        var currentUser = this.cookieService.get(COOKIE_NAME);
        return null != currentUser && '' !== currentUser;
    };
    /**
     * Performs user authentication.
     *
     * This method sends appropriate 'POST' request to REST API authentication end-point, and converts the returned
     * information about the authenticated user into {@link AuthenticatedUser} instance.
     *
     * If REST will respond with 'Bad Request' (400) error, we do assume that authentication was unsuccessful,
     * and return null to the caller, to let him know about it.
     *
     * @param userCredentials user's credentials
     */
    AuthenticationService.prototype.login = function (userCredentials) {
        var _this = this;
        var formData = new FormData();
        formData.append('username', userCredentials.username);
        formData.append('password', userCredentials.password);
        return this.http
            .post('login', formData)
            .pipe(map(function (response) {
            var user;
            if (response) {
                user = AuthenticatedUser.fromJSON(response);
                _this.cookieService.set(COOKIE_NAME, JSON.stringify(user));
            }
            return user;
        }), catchError(this.handleError));
    };
    AuthenticationService.prototype.logout = function () {
        var _this = this;
        return this.http
            .get('logout')
            .toPromise()
            .then(function (response) { return _this.clearSession(); });
    };
    AuthenticationService.prototype.resetPassword = function (resetPasswordParams) {
        var httpParams = new HttpParams()
            .set('licenseId', resetPasswordParams.licenseId.toString());
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.post(appSettings.resetPasswordURL, httpParams, options);
    };
    AuthenticationService.prototype.resetMyPassword = function () {
        return this.resetPassword({ licenseId: this.getCurrentUser().dealerId });
    };
    AuthenticationService.prototype.clearSession = function () {
        this.cookieService.delete(COOKIE_NAME);
    };
    AuthenticationService.prototype.handleError = function (error) {
        if (isDevMode()) {
            console.error('Authentication error: ', error);
        }
        if ((error instanceof HttpErrorResponse) && (error.status === 400)) {
            return Promise.resolve(null);
        }
        return Promise.reject(error.message || error);
    };
    AuthenticationService.ngInjectableDef = i0.defineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(i0.inject(i1.HttpClient), i0.inject(i2.ToastrService), i0.inject(i3.CookieService)); }, token: AuthenticationService, providedIn: "root" });
    return AuthenticationService;
}());
export { AuthenticationService };
